import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=6c6c39ce&scoped=true&"
import script from "./MyProfile.ts?vue&type=script&lang=ts&"
export * from "./MyProfile.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c39ce",
  null
  
)

export default component.exports